import { injectable } from '@wix/typesafe-inversify';
import type { IConsoleLogger } from './IConsoleLogger';

@injectable()
export class ConsoleLogger implements IConsoleLogger {
  error(...args: any) {
    console.error(...args);
  }
  warn(...args: any) {
    console.warn(...args);
  }
}
